<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
        <a [routerLink]="['/']">Home</a>
    </li>
    <li>
        <a [routerLink]="['/agenda']">Agenda</a>
    </li>
    <li>
        <span>{{PageTitle}}</span>
    </li>
</ul>


<section class="card">
    <div class="card-header" *ngIf="!ismodal">
        <span class="cat__core__title">
            <strong>{{PageTitle}} <span *ngIf="RecipientName">:- {{RecipientName}}</span></strong>
        </span>
        <span style="float: right">
            <button type="button" class="btn btn-sm btn-default" (click)="back()">
                <i class="fa fa-chevron-circle-left"></i>&nbsp;Back</button>

        </span>

    </div>
    <div class="modal-header" *ngIf="ismodal">
        <h5 class="modal-title">Add Recipient</h5>
        <button aria-label="Close" class="close" type="button" (click)="activeModal.dismiss('close')">
          <i class="fa fa-times"></i>
        </button>
      </div>
    <div class="card-block">
        <div class="row">

            <div class="col-md-12">
                <form [formGroup]="addUPSIRecipient" class="well" NoValidate>

                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-2">
                                <label class="form-control-label">Name</label>
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <input type="text" [formControl]="addUPSIRecipient.controls['Name']"
                                        class="form-control" style="padding:6px;">
                                    <div *ngIf="addUPSIRecipient.controls['Name'].hasError('pattern')"
                                        class="form-control-error-custom">
                                        Name is not valid.
                                    </div>
                                    <div *ngIf="addUPSIRecipient.controls['Name'].hasError('required') && addUPSIRecipient.controls['Name'].touched"
                                        class="form-control-error-custom">
                                        Name is required.
                                    </div>

                                    <div *ngIf="!addUPSIRecipient.controls['Name'].hasError('required') && addUPSIRecipient.controls['Name'].hasError('whitespace') && addUPSIRecipient.controls['Name'].touched"
                                        class="form-control-error-custom">
                                        Name is not valid.
                                    </div>
                                    <div *ngIf="addUPSIRecipient.controls['Name'].hasError('maxlength')"
                                        class="form-control-error-custom">
                                        Name must be less than 50 characters.
                                    </div>
                                    <div *ngIf="addUPSIRecipient.get('Name')?.errors?.['inappropriateLanguage'] && addUPSIRecipient.get('Name')?.touched"
                                        class="form-control-error-custom">
                                        {{ addUPSIRecipient.get('Name')?.errors?.['inappropriateLanguage']?.message }}
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-2">
                                <label class="form-control-label">Recipient Code</label>

                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <input type="text" [formControl]="addUPSIRecipient.controls['EmpCode']"
                                        class="form-control" style="padding:6px;">
                                    <div *ngIf="addUPSIRecipient.controls['EmpCode'].hasError('required') && addUPSIRecipient.controls['EmpCode'].touched"
                                        class="form-control-error-custom">
                                        Employee Code is required.
                                    </div>
                                    <div *ngIf="addUPSIRecipient.controls['EmpCode'].hasError('pattern')"
                                        class="form-control-error-custom">
                                        Employee Code is not valid.
                                    </div>
                                    <div *ngIf="addUPSIRecipient.controls['EmpCode'].hasError('maxlength')"
                                        class="form-control-error-custom">
                                        Employee Code must be less than 25 characters.
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-2">
                                <label class="form-control-label">Designation</label>
                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <input type="text" [formControl]="addUPSIRecipient.controls['Designation']"
                                        class="form-control" style="padding:6px;">
                                    <div *ngIf="addUPSIRecipient.controls['Designation'].hasError('pattern')"
                                        class="form-control-error-custom">
                                        Designation is not valid.
                                    </div>
                                    <div *ngIf="addUPSIRecipient.controls['Designation'].hasError('maxlength')"
                                        class="form-control-error-custom">
                                        Designation must be less than 50 characters.
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-2">
                                <label class="form-control-label">Company Name</label>
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <input type="text" [formControl]="addUPSIRecipient.controls['Department']"
                                        class="form-control" style="padding:6px;">
                                    <div *ngIf="addUPSIRecipient.controls['Department'].hasError('required') && addUPSIRecipient.controls['Department'].touched"
                                        class="form-control-error-custom">
                                        Company Name is required.
                                    </div>

                                    <div *ngIf="!addUPSIRecipient.controls['Department'].hasError('required') && addUPSIRecipient.controls['Department'].hasError('whitespace') && addUPSIRecipient.controls['Department'].touched"
                                    class="form-control-error-custom">
                                    Company Name isnot valid.
                                </div>

                                    <div *ngIf="addUPSIRecipient.controls['Department'].hasError('pattern')"
                                        class="form-control-error-custom">
                                        Company Name is not valid.
                                    </div>
                                    <div *ngIf="addUPSIRecipient.controls['Department'].hasError('maxlength')"
                                        class="form-control-error-custom">
                                        Company Name must be less than 50 characters.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <label class="form-control-label">Address_1</label>
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <input type="text" [formControl]="addUPSIRecipient.controls['Address_1']"
                                        class="form-control" style="padding:6px;">

                                    <div *ngIf="addUPSIRecipient.controls['Address_1'].hasError('required') && addUPSIRecipient.controls['Address_1'].touched"
                                        class="form-control-error-custom">
                                        Address_1 is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <label class="form-control-label">Address_2</label>

                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <input type="text" [formControl]="addUPSIRecipient.controls['Address_2']"
                                        class="form-control" style="padding:6px;">
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <label class="form-control-label">Address_3</label>

                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <input type="text" [formControl]="addUPSIRecipient.controls['Address_3']"
                                        class="form-control" style="padding:6px;">
                                </div>
                            </div>

                            <div class="col-lg-2">
                                <label class="form-control-label">City</label>

                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <input type="text" [formControl]="addUPSIRecipient.controls['city']"
                                        class="form-control" style="padding:6px;">
                                </div>
                            </div>

                            <div class="col-lg-2">
                                <label class="form-control-label">PIN</label>

                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <input type="text" [formControl]="addUPSIRecipient.controls['pin']"
                                        class="form-control" style="padding:6px;" pattern="^\d{6}$"
                                        (keydown)="onlyNumberPIN($event)">
                                    <div *ngIf="addUPSIRecipient.controls['pin'].hasError('pattern')"
                                        class="form-control-error-custom">
                                        PIN is not valid.
                                    </div>
                                </div>
                            </div>



                            <div class="col-lg-2">
                                <label class="form-control-label">Type of Recipient</label>
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <select class="form-control"
                                        [formControl]="addUPSIRecipient.controls['type_of_recipient']"
                                        style="padding:6px;" (change)="onChangeReType()">
                                        <option value="" [selected]="true">select</option>
                                        <option value="Company"> Company</option>
                                        <option value="Firm"> Firm</option>
                                        <option value="Individual"> Individual</option>
                                        <option value="LLP"> LLP</option>
                                        <option value="Other"> Other</option>
                                     
                                    </select>
                                    <div *ngIf="addUPSIRecipient.controls['type_of_recipient'].hasError('required') && addUPSIRecipient.controls['type_of_recipient'].touched"
                                        class="form-control-error-custom">
                                        Please select Type of Recipient.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2" *ngIf="RecipientType == 'Other'">
                                <label class="form-control-label">Specify type of Recipient
                                <span _ngcontent-c2="" style="color: red;">*</span></label>
                            </div>
                            <div class="col-lg-4" *ngIf="RecipientType == 'Other'">
                                <div class="form-group">
                                    <input type="text" [formControl]="addUPSIRecipient.controls['other_recipient']"
                                        class="form-control" style="padding:6px;" pattern='^[ a-zA-Z0-9!@#$*%_?<>|=&^()\\-`.+,:/\"]*'
                                        (change)="otherRecipient($event)" (keydown)="otherRecipient($event)">

                                    <div *ngIf="addUPSIRecipient.controls['other_recipient'].hasError('pattern')"
                                        class="form-control-error-custom">
                                        Other Recipient is invalid.
                                    </div>
                                    <div *ngIf="other_recipient_fields" class="form-control-error-custom">
                                        Other Recipient is required.
                                    </div>
                                </div>
                            </div>



                            <div class="col-lg-2">
                                <label class="form-control-label">Unique Identifier</label>
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <select class="form-control"
                                        [formControl]="addUPSIRecipient.controls['Unique_Identifier_Type']"
                                        style="padding:6px;" (change)="onChangeUIType()">
                                        <option value="" [selected]="true">select</option>
                                        <option value="PAN"> PAN</option>
                                        <option value="Other"> Other</option>
                                    </select>
                                    <div *ngIf="addUPSIRecipient.controls['Unique_Identifier_Type'].hasError('required') && addUPSIRecipient.controls['Unique_Identifier_Type'].touched"
                                        class="form-control-error-custom">
                                        Please elect Unique Identifier.
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-2">
                                <label class="form-control-label">Upload Document</label>
                            </div>
                            <div class="col-lg-4"   > 
                                <label class="input-group">
                                    <input data-toggle="tooltip" type="text"
                                        [value]="(fileNameArray.length+listOfFiles.length) > 0 ? listOfFiles.length + fileNameArray.length  + ' Files Selected':' File Not Available'"
                                        class="form-control" [disabled]= "true">
                                    <span class="input-group-addon warning"
                                        (click) = "initiateUploadDocument($event)">
                                        <i class="fa fa-upload"></i>
                                    </span>

                                </label>
                                
                            </div>

                                <!-- <div class="col-lg-4" *ngIf = "!DocumentFileDoc">
                                    <div class="form-group">
                                        <input type="file" class='form-control' (change)="fileChanged($event)"
                                        accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx"> 
                                        <span style="color: red" *ngIf="!fileExtension">Please upload valid file format.</span>
                                    </div>
                                </div> -->
    
                                <!-- <div class="col-lg-2" *ngIf = "DocumentFileDoc">
                                    <label class="form-control-label">Document</label>
                                </div>
                                <div class="col-lg-4" *ngIf = "DocumentFileDoc" > 
                                  
                                    <a class="btn btn-sm btn-default"><span (click)="downloadFile()">{{FileNameO }}</span>&nbsp;<span (click)="downloadFile()" style="margin-left: 10px"><i class="fa fa-download"></i></span><span (click)="deleteFile()" style="margin-left: 10px"><i class="fa fa-close" style="color: white"></i></span></a>
                                    
                                </div> -->

                            <div class="col-lg-2" *ngIf="documentType == 'PAN'">
                                <label class="form-control-label">PAN</label>
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </div>
                            <div class="col-lg-4" *ngIf="documentType == 'PAN'">
                                <div class="form-group">
                                    <input type="text" [formControl]="addUPSIRecipient.controls['Document_No']"
                                        class="form-control " style="padding:6px;text-transform:uppercase;"
                                        (focusout)="DocumentValidation($event)"  (change)="DocumentValidation($event)"
                                        (keydown)="DocumentValidation($event)">

                                    <div *ngIf="checkOtherDocumentNoValD"
                                        class="form-control-error-custom">
                                        PAN is invalid.
                                    </div>
                                    <div *ngIf="panNumberReq"
                                        class="form-control-error-custom">
                                        PAN is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2" *ngIf="documentType == 'Other'">
                                <label class="form-control-label">Other Document Name &nbsp;<span _ngcontent-c2="" style="color: red;">*</span></label>
                                
                            </div>
                            <div class="col-lg-4" *ngIf="documentType == 'Other'">
                                <div class="form-group">
                                    <input type="text" [formControl]="addUPSIRecipient.controls['other_document_name']"
                                        class="form-control" style="padding:6px;"
                                        (change)="otherDocumentNameFun($event)"
                                        (keydown)="otherDocumentNameFun($event)">
                                    <div *ngIf="otherDocumentName" class="form-control-error-custom">
                                        Other Document Name is required.
                                    </div>


                                    <div *ngIf="addUPSIRecipient.controls['other_document_name'].hasError('pattern')"
                                        class="form-control-error-custom">
                                        Other Document Name is not valid.
                                    </div>
                                    <div *ngIf="addUPSIRecipient.controls['other_document_name'].hasError('maxlength')"
                                        class="form-control-error-custom">
                                        Other Document Name must be less than 50 characters.
                                    </div>
                                </div>
                            </div>


                            <div class="col-lg-2" *ngIf="documentType == 'Other'">
                                <label class="form-control-label">Other Document No &nbsp;<span _ngcontent-c2="" style="color: red;">*</span></label>
                                
                            </div>
                            <div class="col-lg-4" *ngIf="documentType == 'Other'">
                                <div class="form-group">
                                    <input type="text" [formControl]="addUPSIRecipient.controls['Document_No']"
                                        class="form-control" style="padding:6px;" (focusout)="otherDocumentValidation($event)"  (change)="otherDocumentValidation($event)"
                                        (keydown)="otherDocumentValidation($event)">

                                    <div *ngIf="checkOtherDocumentNoVal"
                                        class="form-control-error-custom">
                                        Document number is invalid.
                                    </div>
                                    <div *ngIf="otherNumberReq"
                                        class="form-control-error-custom">
                                        Document number is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <label class="form-control-label">Email ID</label>
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </div>

                            <div class="col-lg-4">
                                <div class="form-group">
                                    <input type="text" [formControl]="addUPSIRecipient.controls['email_id']"
                                        class="form-control" style="padding:6px;" (focusout)="checkuniqueEmail($event)">
                                    <div *ngIf="addUPSIRecipient.controls['email_id'].hasError('required') && addUPSIRecipient.controls['email_id'].touched"
                                        class="form-control-error-custom">
                                        Email id required.
                                    </div>
                                    <div *ngIf="addUPSIRecipient.controls['email_id'].hasError('pattern')"
                                        class="form-control-error-custom">
                                        Email ID is not valid.
                                    </div>
                                    <div *ngIf="checkUniqueEmail"  class="form-control-error-custom">

                                        This Email id is already exist.
                                    </div>

                                </div>
                            </div>

                            <div class="col-lg-2">
                                <label class="form-control-label">Mobile Number</label>
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <input [formControl]="addUPSIRecipient.controls['ContactNumber']"
                                        class="form-control" pattern="^\d{10}$" (keydown)="onlyNumber($event)">

                                    <div *ngIf="addUPSIRecipient.controls['ContactNumber'].hasError('required') && addUPSIRecipient.controls['ContactNumber'].touched"
                                        class="form-control-error-custom">
                                        Mobile Number is required.
                                    </div>
                                    <div *ngIf="addUPSIRecipient.controls['ContactNumber'].hasError('pattern')"
                                        class="form-control-error-custom">
                                        Mobile Number is not valid.
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <label class="form-control-label">Tel Number</label>
                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <input [formControl]="addUPSIRecipient.controls['tele_Number']" class="form-control"
                                       pattern='^[ a-zA-Z0-9!@#$*%_?<>|=&^()\\-`.+,:/\"]*'>
                                    <div *ngIf="addUPSIRecipient.controls['tele_Number'].hasError('pattern')"
                                        class="form-control-error-custom">
                                        Telephone Number is not valid.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="modal-footer" *ngIf="!ismodal">
                        <button id="btnSaveMeeting" type="button" *ngIf="!isEdit" class="btn btn-sm btn-primary"
                            [disabled]="!addUPSIRecipient.valid || disabledOnclick || other_recipient_fields || otherDocumentName || checkUniqueEmail || checkOtherDocumentNoVal || checkOtherDocumentNoValD || panNumberReq || otherNumberReq || !fileExtension"
                            (click)="addAndUpdateRecipient()">
                            <i class="fa fa-save"></i>&nbsp;Save</button>

                        <button id="btnSaveMeeting" type="button" *ngIf="isEdit" class="btn btn-sm btn-primary"
                            [disabled]="!addUPSIRecipient.valid || disabledOnclick  || other_recipient_fields || otherDocumentName || checkUniqueEmail || checkOtherDocumentNoVal || checkOtherDocumentNoValD || panNumberReq || otherNumberReq || !fileExtension"
                            (click)="addAndUpdateRecipient()">
                            <i class="fa fa-save"></i>&nbsp;Update</button>

                        <button type="button" class="btn-sm btn btn-default" data-toggle="modal"
                            data-target="#clearMeetingDataModal">
                            <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                    </div>

                    <div class="modal-footer" *ngIf="ismodal">
                        <button id="btnSaveMeeting" type="button" *ngIf="!isEdit" class="btn btn-sm btn-primary"
                            [disabled]="!addUPSIRecipient.valid || disabledOnclick || other_recipient_fields || otherDocumentName || checkUniqueEmail || checkOtherDocumentNoVal || checkOtherDocumentNoValD || panNumberReq || otherNumberReq"
                            (click)="addAndUpdateRecipient()">
                            <i class="fa fa-save"></i>&nbsp;Save</button>
                            <button type="button" class="btn-sm btn btn-default" (click)="activeModal.dismiss()">
                            <i class="fa fa-refresh"></i>&nbsp;Cancel</button>
                    </div>

                    <!-- <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby=""
                        aria-hidden="true" style="top: 50px;">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div id="alertTitle" class="modal-header" style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                                    Title!
                                </div>
                                <div class="modal-body">
                                    <div id="alertMessage">
                                        Message..
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>--->

                    <div class="modal fade" id="clearMeetingDataModal" tabindex="-1" role="dialog"
                        data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="myModalLabelForDelete">
                                        <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                                        <i class="fa fa-times"></i>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            Are you sure you want to clear Recipient details?
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-sm btn-danger" (click)="clear()"
                                        data-dismiss="modal">
                                        <i class="fa fa-check"></i>&nbsp;Yes</button>
                                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                                        <i class="fa fa-times"></i>&nbsp;No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

</section>
<div class="modal fade modal-size-medium" id="upsiReciepentUploadDialog" tabindex="-1" role="dialog"
                data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                <i class="fa fa-upload"></i>
                                <span id="UpsiUploadTitle"></span>
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="col-md-12">
                                <div class="row collapse1">
                                    <span class="cat__core__title">
                                        Existing Files
                                    </span>

                                    <table class="table table-hover compact cell-border nowrap stripe"
                                        style="cursor: pointer;">
                                        <thead>
                                            <tr>

                                                <th>Filename</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody *ngIf= "fileNameArray || listOfFiles">
                                            <tr *ngFor="let file of fileNameArray; let index = index">
                                                <td tabindex="1" style="cursor: move; width: 70%;">
                                                    {{file}}
                                                </td>
                                                <td>
                                                    <button type="button" class="btn-sm btn btn-warning"
                                                       (click)="downloadFile(file)">
                                                        <span class="fa fa-download"></span>
                                                    </button>
                                                    <button type="button" class="btn-sm btn btn-danger"
                                                    (click)="deleteFile(index)">
                                                        <span class="fa fa-close"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr *ngFor="let selected of listOfFiles;let index = index">

                                                <td tabindex="1" style="cursor: move; width: 70%;">
                                                    {{selected}}
                                                </td>
                                                <td>
                                                    
                                                    <button type="button" class="btn-sm btn btn-danger"
                                                        (click)="removeSelectedFile(index)">
                                                        <span class="fa fa-close"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                            
                                        </tbody>
                                    </table>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label class="col-form-label" for="l5">
                                                <span>Document Attachment
                                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                                </span>
                                            </label>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="form-group">
                                                
                                                <input type="file" class='form-control fileUpload'
                                                #attachments type="file" (change)="onFileChanged($event)" #fileInput multiple="true"
                                                    accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx"
                                                     />
                                                <!-- <span *ngIf="typeHasError" style="color: red">
                                                    Please upload valid file format.
                                                </span> -->

                                            </div>
                                            <!-- {{fileHasError | json}} -->
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">

                            <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary"
                             data-dismiss="modal">
                                <i class="fa fa-save"></i>&nbsp;Upload</button>

                            <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                                <i class="fa fa-times"></i>&nbsp;Close</button>

                        </div>
                    </div>
                </div>
</div>
<app-alert></app-alert>